// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #498bc9;
  --secondary-color: #87b0d7;
  --border-color: #dbdade;
  --text-color: #4b465c;
}

/* .mini-sidebar .sidebar-menu ul ul {
  display: none !important;
} */
.mini-sidebar.expand-menu ul .subdrop ~ ul {
  display: block !important;
}
.table thead tr th {
  padding: 0.75rem;
}
.table tbody td {
  padding: 0.75rem;
}
.p-paginator-icon {
  padding: 0 !important;
}
.p-paginator-current {
  position: absolute;
  left: 15px;
}
.p-paginator {
  justify-content: flex-end !important;
}
.p-datatable .p-column-header-content {
  justify-content: space-between;
}
.modal-input .select-input .css-13cymwt-control {
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #dbdade;
}
.modal-input .select-input .css-qbdosj-Input {
  height: 39px;
  margin: 0;
  padding: 0;
}
.modal-input .select-input .css-1fdsijx-ValueContainer {
  height: 40px;
  padding-top: 0;
}
.p-paginator-pages {
  display: flex;
  gap: 5px;
}
.p-paginator-page,
.p-paginator-element {
  padding: 6px 12px !important;
  border-radius: 6px;
}
.p-paginator-prev {
  margin-right: 5px;
}
.p-paginator-next {
  margin-left: 5px;
}

.table tbody tr:last-child {
  border-bottom: 1px solid #fff;
}
.p-datatable-wrapper {
  border: 1px solid #dbdade;
}
.table.dataTable {
  border: none;
}
.p-paginator {
  margin-top: 10px;
}
.p-paginator-element svg {
  background-color: transparent;
}
.table > :not(:first-child) {
  border-color: transparent;
}
.error-input {
  color: red !important;
  border-color: red !important;
}
.select-error {
  border: 1px solid red !important;
  border-radius: 5px;
}
.p-checkbox .p-checkbox-box.p-highlight {
  border-color: var(--primary-color);
  background: var(--primary-color);
}
.error-message {
  font-size: 13px !important;
  color: red !important;
  padding-top: 0 !important;
  margin: 0;
}
:where(.css-dev-only-do-not-override-42nv3w).ant-select-single {
  width: 100%;
  height: 40px !important;
}
.p-calendar {
  height: 40px;
}
.p-calendar .p-inputtext {
  font-size: 14px;
}
.action-table li button {
  background: transparent;
  font-size: 18px;
  width: 25px;
  height: 25px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
}
.signature-img.signtab {
  background: #fff;
}
.form-wrap > div {
  display: flex;
  justify-content: space-between;
}
.twofa_otpinput {
  width: 3rem !important;
}

.p-paginator-current {
  left: -5px !important;
}
.crm_pagination {
  position: relative;
}

.accessDenied_golb {
  position: relative;
  box-sizing: border-box;
}

.accessDenied_body {
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom right, #eee, #aaa);
}

h1 {
  margin: 40px 0 20px;
}

.lock {
  width: 4.5rem;
}

.userActivity_scrollbar .timeline-div {
  padding: 0px 0px 0px 50px;
}
.userActivity_scrollbar .timeline-div::after {
  left: 20.5px;
}

.userActivity_scrollbar {
  padding: 0px 15px 0px 10px;
}

.userActivity_card:hover .userActivity_scrollbar::-webkit-scrollbar-thumb {
  background-color: #aaa !important;
}

.userActivity_scrollbar::-webkit-scrollbar {
  width: 0.5em !important;
  background-color: transparent !important;
}

.userActivity_scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background-color: transparent !important;
}

.role_module_label {
  color: #7a66b7 !important;
}

.role-management {
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 10px;
}

.role-permissioncontent {
  max-height: 40vh;
  overflow-y: auto;
  padding: 5px;
}

.role_management_scrollbar:hover::-webkit-scrollbar-thumb {
  background-color: #aaa !important;
}

.role_management_scrollbar::-webkit-scrollbar {
  width: 0.5em !important;
  background-color: transparent !important;
}

.role_management_scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background-color: transparent !important;
}

.forgotPassword > h5 {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow-x: clip;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;GAEG;AACH;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[":root {\r\n  --primary-color: #498bc9;\r\n  --secondary-color: #87b0d7;\r\n  --border-color: #dbdade;\r\n  --text-color: #4b465c;\r\n}\r\n\r\n/* .mini-sidebar .sidebar-menu ul ul {\r\n  display: none !important;\r\n} */\r\n.mini-sidebar.expand-menu ul .subdrop ~ ul {\r\n  display: block !important;\r\n}\r\n.table thead tr th {\r\n  padding: 0.75rem;\r\n}\r\n.table tbody td {\r\n  padding: 0.75rem;\r\n}\r\n.p-paginator-icon {\r\n  padding: 0 !important;\r\n}\r\n.p-paginator-current {\r\n  position: absolute;\r\n  left: 15px;\r\n}\r\n.p-paginator {\r\n  justify-content: flex-end !important;\r\n}\r\n.p-datatable .p-column-header-content {\r\n  justify-content: space-between;\r\n}\r\n.modal-input .select-input .css-13cymwt-control {\r\n  width: 100%;\r\n  height: 40px;\r\n  border-radius: 6px;\r\n  border: 1px solid #dbdade;\r\n}\r\n.modal-input .select-input .css-qbdosj-Input {\r\n  height: 39px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.modal-input .select-input .css-1fdsijx-ValueContainer {\r\n  height: 40px;\r\n  padding-top: 0;\r\n}\r\n.p-paginator-pages {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n.p-paginator-page,\r\n.p-paginator-element {\r\n  padding: 6px 12px !important;\r\n  border-radius: 6px;\r\n}\r\n.p-paginator-prev {\r\n  margin-right: 5px;\r\n}\r\n.p-paginator-next {\r\n  margin-left: 5px;\r\n}\r\n\r\n.table tbody tr:last-child {\r\n  border-bottom: 1px solid #fff;\r\n}\r\n.p-datatable-wrapper {\r\n  border: 1px solid #dbdade;\r\n}\r\n.table.dataTable {\r\n  border: none;\r\n}\r\n.p-paginator {\r\n  margin-top: 10px;\r\n}\r\n.p-paginator-element svg {\r\n  background-color: transparent;\r\n}\r\n.table > :not(:first-child) {\r\n  border-color: transparent;\r\n}\r\n.error-input {\r\n  color: red !important;\r\n  border-color: red !important;\r\n}\r\n.select-error {\r\n  border: 1px solid red !important;\r\n  border-radius: 5px;\r\n}\r\n.p-checkbox .p-checkbox-box.p-highlight {\r\n  border-color: var(--primary-color);\r\n  background: var(--primary-color);\r\n}\r\n.error-message {\r\n  font-size: 13px !important;\r\n  color: red !important;\r\n  padding-top: 0 !important;\r\n  margin: 0;\r\n}\r\n:where(.css-dev-only-do-not-override-42nv3w).ant-select-single {\r\n  width: 100%;\r\n  height: 40px !important;\r\n}\r\n.p-calendar {\r\n  height: 40px;\r\n}\r\n.p-calendar .p-inputtext {\r\n  font-size: 14px;\r\n}\r\n.action-table li button {\r\n  background: transparent;\r\n  font-size: 18px;\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 0;\r\n  padding: 0;\r\n}\r\n.signature-img.signtab {\r\n  background: #fff;\r\n}\r\n.form-wrap > div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.twofa_otpinput {\r\n  width: 3rem !important;\r\n}\r\n\r\n.p-paginator-current {\r\n  left: -5px !important;\r\n}\r\n.crm_pagination {\r\n  position: relative;\r\n}\r\n\r\n.accessDenied_golb {\r\n  position: relative;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.accessDenied_body {\r\n  height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: linear-gradient(to bottom right, #eee, #aaa);\r\n}\r\n\r\nh1 {\r\n  margin: 40px 0 20px;\r\n}\r\n\r\n.lock {\r\n  width: 4.5rem;\r\n}\r\n\r\n.userActivity_scrollbar .timeline-div {\r\n  padding: 0px 0px 0px 50px;\r\n}\r\n.userActivity_scrollbar .timeline-div::after {\r\n  left: 20.5px;\r\n}\r\n\r\n.userActivity_scrollbar {\r\n  padding: 0px 15px 0px 10px;\r\n}\r\n\r\n.userActivity_card:hover .userActivity_scrollbar::-webkit-scrollbar-thumb {\r\n  background-color: #aaa !important;\r\n}\r\n\r\n.userActivity_scrollbar::-webkit-scrollbar {\r\n  width: 0.5em !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.userActivity_scrollbar::-webkit-scrollbar-thumb {\r\n  border-radius: 10px !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.role_module_label {\r\n  color: #7a66b7 !important;\r\n}\r\n\r\n.role-management {\r\n  max-height: 50vh;\r\n  overflow-y: auto;\r\n  padding-right: 10px;\r\n}\r\n\r\n.role-permissioncontent {\r\n  max-height: 40vh;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n}\r\n\r\n.role_management_scrollbar:hover::-webkit-scrollbar-thumb {\r\n  background-color: #aaa !important;\r\n}\r\n\r\n.role_management_scrollbar::-webkit-scrollbar {\r\n  width: 0.5em !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.role_management_scrollbar::-webkit-scrollbar-thumb {\r\n  border-radius: 10px !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.forgotPassword > h5 {\r\n  max-width: 300px;\r\n  text-overflow: ellipsis;\r\n  overflow-x: clip;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
